import api from "./axios";

const authHeaders = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

export const getLanguages = (token) => api.get("/languages", authHeaders(token));
export const getLanguage = (id, token) => api.get(`/languages/${id}`, authHeaders(token));
export const createLanguage = (data, token) => api.post("/languages", data, authHeaders(token));
export const updateLanguage = (id, data, token) => api.put(`/languages/${id}`, data, authHeaders(token));
export const toggleLanguage = (id, token) => api.put(`/languages/toggle/${id}`, {}, authHeaders(token));
export const getCountriesByLanguage = (languageId, token) => api.get(`/languages/${languageId}/countries`, authHeaders(token));
export const deleteLanguages = (ids, token) => api.post("/languages/delete", { ids }, authHeaders(token));